import { Database, Link, Cloud, Server } from "lucide-react";

export const FeaturesSection = () => {
  const features = [
    {
      icon: <Database className="h-12 w-12 text-blue-600" />,
      title: "Data Warehousing",
      description: "Centralize your data from multiple sources into a single, organized warehouse."
    },
    {
      icon: <Link className="h-12 w-12 text-blue-600" />,
      title: "API Integration",
      description: "Connect with any REST or GraphQL API to enable seamless data flow between systems."
    },
    {
      icon: <Cloud className="h-12 w-12 text-blue-600" />,
      title: "Cloud Sync",
      description: "Synchronize data across cloud platforms with automated workflows and schedules."
    },
    {
      icon: <Server className="h-12 w-12 text-blue-600" />,
      title: "ETL Processing",
      description: "Extract, transform, and load data with powerful processing capabilities."
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <h2 className="text-3xl font-bold text-center mb-12">
          Comprehensive Data Integration Features
        </h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="text-center p-6 rounded-lg hover:bg-blue-50 transition-colors"
            >
              <div className="mb-4 flex justify-center">{feature.icon}</div>
              <h3 className="text-xl font-semibold mb-2">{feature.title}</h3>
              <p className="text-gray-600">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};